import React from "react"

const FAQs = () => {
	return (
		<>
		</>
	)
}

export default FAQs